var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-2 mx-auto text-center"},[_c('audio',{ref:"audio",attrs:{"src":_vm.dataUrl,"alt":_vm.value.name,"title":_vm.value.name,"width":"100%","controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }